import React from "react";
import MuiAccordion from "@mui/material/Accordion";

export const Accordion: React.FC<{
  children: NonNullable<React.ReactNode>;
}> = ({ children }) => (
  <MuiAccordion
    slotProps={{ heading: { component: "h4" } }}
    sx={{
      boxShadow: "none",
      border: "none",
      "&:before": {
        display: "none",
      },
      "&:not(:last-child)": {
        borderBottom: "1px solid #e0e0e0",
      },
      borderRadius: 0,
      backgroundColor: "transparent",
    }}
  >
    {children}
  </MuiAccordion>
);
